import { toast } from "sonner";

// Show a plain-language toast for an AI request error; blob responses are decoded first.
export async function aiError(e, fallback = "AI request failed. Please try again.") {
  let detail = e?.response?.data?.detail;
  const data = e?.response?.data;
  if (!detail && data instanceof Blob) {
    try { detail = JSON.parse(await data.text()).detail; } catch (err) { /* not JSON */ }
  }
  const msg = detail || fallback;
  if (/OpenAI key|Settings/i.test(msg)) {
    toast.error(msg, { action: { label: "Open Settings", onClick: () => { window.location.href = "/settings"; } } });
  } else {
    toast.error(msg);
  }
  return msg;
}
